module.exports = __webpack_public_path__ + "img/ics_f_warning_triangles.76a50d83.svg";